const IUBENDA_CONSENT_MANAGER_PLUGIN = 'IubendaConsentManagerPlugin';
const IUBENDA_CONSENT_EXAMPLE_COOKIE_NAME = '_iub_cs-252372';
const IUBENDA_CONSENT_COOKIE_NAME_PATTERN = /^_iub_cs-\d+$/;
export {
  IUBENDA_CONSENT_MANAGER_PLUGIN,
  IUBENDA_CONSENT_COOKIE_NAME_PATTERN,
  IUBENDA_CONSENT_EXAMPLE_COOKIE_NAME,
};
